"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _reactComponents = require("@cimpress/react-components");

var _sharedtypes = require("../../shared/sharedtypes");

var SearchComponent = function SearchComponent(_ref) {
  var availableFulfillmentConfigurations = _ref.availableFulfillmentConfigurations,
      showVersions = _ref.showVersions,
      filterFulfillmentConfigurations = _ref.filterFulfillmentConfigurations;

  var _useTranslation = (0, _reactI18next.useTranslation)('search'),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      filterString = _useState2[0],
      setFilterString = _useState2[1];

  var isSearchDisabled = showVersions || availableFulfillmentConfigurations.length === 0;
  return /*#__PURE__*/_react["default"].createElement(_reactComponents.TextField, {
    name: "fulfillmentConfigurationsSearch",
    label: t('searchFieldLabel'),
    value: filterString,
    onChange: function onChange(_ref2) {
      var newFilterString = _ref2.target.value;
      setFilterString(newFilterString);
      filterFulfillmentConfigurations({
        newFilterString: newFilterString
      });
    },
    disabled: isSearchDisabled
  });
};

SearchComponent.propTypes = {
  availableFulfillmentConfigurations: _propTypes["default"].arrayOf(_sharedtypes.FulfillmentConfiguration).isRequired,
  showVersions: _propTypes["default"].bool.isRequired,
  filterFulfillmentConfigurations: _propTypes["default"].func.isRequired
};
var _default = SearchComponent;
exports["default"] = _default;